type CartEndpoint = 'add' | 'change';

export default async (
  endpoint: CartEndpoint,
  formData: FormData,
  callback?: Function,
) => {
  document.dispatchEvent(new Event('cart:disable'));
  formData.set('sections', 'cart-drawer,header');

  const response = await fetch(`/cart/${endpoint}.js`, {
    method: 'post',
    body: formData,
  });

  const data = await response.json();

  if (data.status) {
    alert(`${data.message}: ${data.description}`); // eslint-disable-line no-alert
  } else {
    document.dispatchEvent(new CustomEvent('cart:updated', {
      detail: {
        cartDrawerMarkup: data.sections['cart-drawer'],
        data,
        headerMarkup: data.sections.header,
      },
    }));
  }

  if (callback) {
    callback();
  }

  return document.dispatchEvent(new Event('cart:enable'));
};
